import {
	IconButton,
	Sidebar,
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
	ReceiptCheckBox as RCB,
} from '../../components';
import styles from '../../assets/styles/Receipt/Receipt.module.scss';
import { ReceiptSummaryContainer } from '../../containers';
import { Formik } from 'formik';
import { nanoid } from 'nanoid';
import React from 'react';

const EditReceipt = ({
	stage2,
	goToStage2,
	anotherService,
	addAnotherService,
	plusService,
	removeService,
	receiptDetailsValidation,
}) => {
	return (
		<div>
			{!stage2 && (
				<div>
					<MimaText
						variant="subtitle"
						color="var(--color-primary)"
						align="center"
						mb={4}>
						Create Receipt
					</MimaText>
					<Formik
						initialValues={{
							id: '',
							dateCreated: '',
							dateDue: '',
							customer: '',
							price: '',
							service: '',
							quantity: '',
							discount: '',
						}}
						validationSchema={receiptDetailsValidation()}
						onSubmit={payload => {
							payload.id = nanoid();
							const newInvoiceItem = payload;
						}}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<div>
								<MimaDropdown
									labelTitle="Bill To"
									placeholder="Select Customer"
									name="customer"
								/>

								{anotherService.map((more, index) => {
									return (
										<div key={index}>
											<MimaInput
												type="text"
												labelTitle="What Service is the Invoice for?"
												placeholder="Service"
												name="service"
												mb={2}
												mt={2}
												value={more.service}
												onChange={handleChange}
												onBlur={handleBlur}
											/>
											<div className={styles.receipt__beside}>
												<MimaInput
													type="text"
													labelTitle="Unit Price"
													placeholder="0.00"
													name="price"
													mr={2}
													value={more.price}
													onChange={handleChange}
													onBlur={handleBlur}
													width={18}
												/>
												<MimaInput
													type="text"
													labelTitle="Quantity"
													placeholder="1"
													name="quantity"
													value={more.quantity}
													onChange={handleChange}
													onBlur={handleBlur}
													width={18}
												/>
											</div>
											<MimaInput
												type="text"
												labelTitle="Amount"
												placeholder="0.00"
												name="amount"
												mb={2}
												value={more.amount}
												onChange={handleChange}
												onBlur={handleBlur}
											/>
											{plusService && (
												<div className={styles.summary__line}></div>
											)}
										</div>
									);
								})}

								<div className={plusService ? styles.receipt__beside : null}>
									<MimaButton
										title={plusService ? 'Add' : 'Add Another Service'}
										variant={plusService ? 'small' : 'text'}
										type="button"
										onClick={addAnotherService}
									/>
									{plusService && (
										<MimaButton
											title="Remove"
											variant="small"
											type="button"
											buttonColor="var(--color-dark-3)"
											mb={2}
											onClick={removeService}
										/>
									)}
								</div>

								<MimaInput
									type="text"
									labelTitle="Issue date"
									placeholder="DD/MM/YY"
									name="discount"
									mb={2}
									value={values.date}
									onChange={handleChange}
									onBlur={handleBlur}
								/>

								<MimaText variant="small" ml={2}>
									Payment Type
								</MimaText>
								<div className={styles.receipt__checks}>
									<RCB title="Cash" id="cash" name="payType" />
									<RCB title="Transfer" id="transfer" name="payType" />
									<RCB title="P.O.S" id="pos" name="payType" />
								</div>

								<MimaText variant="small" ml={2}>
									Payment Value
								</MimaText>
								<div className={styles.receipt__checks}>
									<RCB title="Full Payment" id="full" name="payValue" />
									<RCB title="Part Payment" id="part" name="payValue" />
								</div>

								<MimaText variant="small" ml={2}>
									Is tax Included
								</MimaText>
								<div className={styles.receipt__checks}>
									<RCB title="Yes" id="taxYes" name="taxed" />
									<RCB title="No" id="taxNo" name="taxed" />
								</div>

								<MimaButton
									title="Continue"
									type="submit"
									onClick={goToStage2}
								/>
							</div>
						)}
					</Formik>
				</div>
			)}

			{stage2 && <ReceiptSummaryContainer />}
		</div>
	);
};

export default EditReceipt;
